<template>
  <div>
    <v-dialog persistent v-model="showMC" v-if="showMC" max-width="760">
      <v-card>
        <v-card-title class="headline">Cajas</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <div class="d-flex mtll">
                  <v-text-field
                    @focus="$event.target.select()"
                    dense
                    v-model.trim="objetoVentaCajas.cliente.nombre"
                    outlined
                    class="mr-2"
                  ></v-text-field>

                  <v-btn
                    @click="abreModalClientesDentroDeCajas()"
                    style="height:40px;"
                    color="primary"
                    ><v-icon dark right>mdi-magnify</v-icon></v-btn
                  >
                </div>
              </v-col>
            </v-row>
            <v-row no-gutters v-for="(caja, index) in objetoVentaCajas.productos" :key="index">
              <v-col lg="6" xl="6" cols="12">
                <v-text-field
                  @focus="$event.target.select()"
                  v-model="caja.cantidad"
                  label="Cantidad"
                  outlined
                  dense
                  class="mr-1"
                ></v-text-field>
              </v-col>
              <v-col style="display:flex;" lg="6" xl="6" cols="12"
                ><v-select
                  class="ml-1 mr-2"
                  v-model="caja.nombreProducto"
                  :items="['Cajas', 'Cinta']"
                  label="Producto"
                  outlined
                  dense
                ></v-select>
                <v-text-field
                  @focus="$event.target.select()"
                  v-model="caja.precio"
                  label="Precio"
                  outlined
                  dense
                  class="mr-1"
                ></v-text-field>
                <v-btn style="height:40px;" @click="borrarProducto(index)" color="red" dark
                  >borrar</v-btn
                >
              </v-col>
            </v-row>
            <v-btn color="blue darken-1" block dark @click="agregarProducto()"
              >agregar producto</v-btn
            >
            <div class="mt-2">
              <h1 style="float:right;">Total venta: {{ totalVenta }}</h1>
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" @click="$emit('cerrarModalCajas')" text>Cancelar</v-btn>
          <v-btn color="blue darken-1" text>Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ModalCliente
      v-if="showMC && showModalClient"
      @cierraModalClienteVentaCajas="cierraModalClienteVentaCajas()"
      clientType="remitenteVentaCajas"
      @insertarClienteventaCajas="insertarClienteventaCajas($event)"
      :show="showModalClient"
    />
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { required } from "vuelidate/lib/validators";
import ModalCliente from "@/components/modales/ModalCliente.vue";

export default {
  name: "ModalNuevaSucursal",
  components: {
    ModalCliente
  },
  data: () => ({
    showModalClient: false,
    objetoVentaCajas: {
      cliente: { nombre: "", id: 0 },
      productos: [
        {
          cantidad: 0,
          precio: 0,
          nombreProducto: "Cajas"
        }
      ]
    }
  }),
  computed: {
    totalVenta() {
      let total = this.objetoVentaCajas.productos
        .map(saleItem => (+saleItem.precio || 0) * (+saleItem.cantidad || 0))
        .reduce((a, b) => a + b);
      return total;
    }
  },
  mounted() {},
  methods: {
    agregarProducto() {
      this.objetoVentaCajas.productos.push({
        cantidad: 0,
        nombreProducto: "Cajas"
      });
    },
    insertarClienteventaCajas(cliente) {
      this.objetoVentaCajas.cliente.nombre = cliente.nombre;
      this.objetoVentaCajas.cliente.id = cliente.nombre;
    },
    abreModalClientesDentroDeCajas() {
      this.showModalClient = true;
    },
    borrarProducto(index) {
      console.log(index);
      if (this.objetoVentaCajas.productos.length > 1) {
        this.objetoVentaCajas.productos.splice(index, 1);
      }
    },
    cierraModalClienteVentaCajas() {
      this.showModalClient = false;
    }
  },
  props: {
    showMC: Boolean
  }
};
</script>
<style lang="css"></style>
